import { Model } from '@models/core/base.model';
import { Employee } from '@models/employee/employee.model';

export class ApprovalInstanceStep extends Model {
    get orderPosition(): string {
        return this._attributes['orderPosition'];
    }

    get status(): string {
        return this._attributes['status'];
    }

    get actionedOn(): Date {
        return this._attributes['actionedOn'];
    }

    get employee(): Employee {
        return this.hasOne(Employee, 'employee');
    }
}
